let httpUser = `http://boxuser-dev.dhsf.xqhuyu.com`
const firstVersoin = `/v1`
const OperationUrl = `/Operation`  // 埋点
let httpContent = process.env.VUE_APP_BASE_URL; // 请求接口 根据环境变量  运营后台
let httpContentHome = process.env.VUE_APP_BASE_URL_OPENAPI;

let baseUrl = ``
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
    httpContent = "http://managerapi.dhsf.xqhuyu.com";
    httpUser = ``;
    baseUrl = `/api`
    httpContentHome = ""
}

export default {
    // 埋点
    operation: {
        // 操作记录
        record: `${httpUser}${firstVersoin}${OperationUrl}/record`,
        // 用户行为记录
        footprint: `${httpUser}${firstVersoin}${OperationUrl}/footprint`,
        // 新前台日志管理接口
        getUpdateLog: `${httpContent}/api/WebsiteLog/getUpdateLog`,
        // 获取新闻列表
        getNewsList: `${httpContentHome}/api/news/list`,
        // 获取新闻详情
        getNewsDetail: `${httpContentHome}/api/news/detail`,
    }
}
